export const japanese = {
  // App.js texts
  app: {
    title: "FrontPlay",
    subtitle: "HTML/CSS/JavaScript プレイグラウンド",
    languageLabel: "言語",
    templateLabel: "コード種別:",
    templatePlaceholder: "選択してください",
    templateBasicHtml: "HTML/CSS/JS",
    templateReact: "React",
    templateCanvas: "Canvas",
    sampleLoad: "サンプル読込",
    backToLandingTitle: "トップへ戻る",
    toolsMenuTitle: "ツールメニュー",
    leaveEditorConfirm: "エディタを離れます。コードはこのセッション中は保持されます。よろしいですか？",
    darkModeTitle: "ダークモード切り替え",
    fullscreenTitle: "プレビューを全画面表示（ブラウザ相当）",
    fullscreenExitTitle: "全画面を終了（Esc）",
    verticalSplit: "上下分割",
    horizontalSplit: "左右分割",
    codeEditor: "コードエディタ",
    run: "実行",
    clear: "クリア",
    clearConfirm: "エディタ・プレビュー・コンソールをすべてクリアします。この操作は元に戻せません。よろしいですか？",
    templateSwitchClearConfirm: "コード種別を切り替えると、現在のコードはクリアされます。よろしいですか？",
    find: "検索",
    findTitle: "コード内を検索",
    findPreviewTitle: "プレビュー内を検索",
    findPlaceholder: "コード内を検索…",
    findPlaceholderPreview: "プレビュー内を検索…",
    linkTitle: "対応表示（HTMLのみ：プレビューで選択した要素のソース行を表示）",
    hideEditorTitle: "コードエディタを非表示",
    showEditorTitle: "コードエディタを表示",
    undoTitle: "元に戻す (Undo)",
    redoTitle: "やり直す (Redo)",
    findPrevTitle: "前へ (Shift+Enter)",
    findNextTitle: "次へ (Enter)",
    findCloseTitle: "閉じる (Esc)",
    linkMatched: "対応するコード: 行{line}（{count}件）",
    linkNoMatch: "ソースに該当なし（動的生成の可能性）",
    preview: "プレビュー",
    devicePreset: "デバイス",
    deviceCustom: "レスポンシブ",
    deviceSizeTitle: "プレビューサイズ",
    paperSkillLabel: "用紙",
    paperSkillNone: "用紙なし",
    paperSkillHint: "ダウンロード／印刷時に @page を付与。AI修正にも同じ設定が渡ります。",
    paperSkills: {
      "a5-portrait": "A5 縦",
      "a5-landscape": "A5 横",
      "a4-portrait": "A4 縦",
      "a4-landscape": "A4 横",
      "a3-portrait": "A3 縦",
      "a3-landscape": "A3 横",
      "letter-portrait": "Letter 縦",
      "letter-landscape": "Letter 横"
    },
    print: "印刷",
    printTitle: "用紙設定付きで印刷（ダウンロードと同じHTML）",
    printCaution: {
      title: "印刷時に余白が消えるおそれがあります",
      itemPadding: "{selector} の余白（padding）が印刷時に消えます",
      itemMargin: "{selector} の余白（margin）が印刷時に消えます",
      fix: "修正する",
      dismiss: "閉じる"
    },
    console: "コンソール",
    consoleOutput: "コンソール出力",
    codePlaceholder: "HTML/CSS/JavaScriptコードをここに記述してください...",
    emptyCodePlaceholder: "テンプレートを選択してコードを書き始めましょう...",
    download: "ダウンロード",
    import: "アップロード",
    emptyPreview: {
      title: "実行結果がここに表示されます",
      description: "コードエディタにコードを書いて「実行」を押すと、ここにプレビューが表示されます。サンプルは上のボタンから読み込めます。"
    },
    templateWelcome: "FrontPlayへようこそ！",
    templateDescription: "HTMLとCSS、JavaScriptをここに書いてください。",
    htmlTemplate: {
      buttonText: "クリックしてね！",
      alertMessage: "JavaScriptからこんにちは！",
      consoleMessage: "ボタンがクリックされました！"
    },
    reactTemplate: {
      title: "Reactカウンター",
      countLabel: "カウント:"
    },
    canvasTemplate: {
      title: "Canvas グラフィックス",
      gradientComment: "グラデーション背景",
      circleComment: "円を描画",
      consoleMessage: "FrontPlay - Canvas描画完了！"
    },
    markdownTemplate: {
      title: "FrontPlay Markdownへようこそ！",
      description: "これは **マークダウン** のサンプルです。",
      featuresTitle: "機能一覧",
      boldItalic: "**太字** と *斜体* のテキスト",
      link: "[リンク](https://example.com)",
      codeBlock: "コードブロック",
      listTitle: "リスト",
      numberedList1: "番号付きリスト",
      numberedList2: "項目2",
      subItem1: "サブ項目",
      subItem2: "もう一つのサブ項目",
      quote1: "これは引用文です。",
      quote2: "マークダウンで簡単に美しい文書が作成できます。",
      closing: "**FrontPlay** でマークダウンをお楽しみください！"
    }
  },

  ai: {
    title: "AI修正",
    instructionLabel: "どこをどう直しますか？",
    placeholder: "例: ボタンを緑にしてリセットボタンを追加",
    apply: "AIで修正",
    applying: "修正中…",
    hint: "プレビューを見ながら指示。⌘/Ctrl+Enter で適用。Undo で直前に戻せます。",
    paperSkillLabel: "用紙スキル",
    paperSkillNone: "なし（通常）",
    paperSkillHint: "ダウンロード／印刷時の用紙。AIは内容を1枚に収めるよう調整します。",
    paperSkills: {
      "a5-portrait": "A5 縦",
      "a5-landscape": "A5 横",
      "a4-portrait": "A4 縦",
      "a4-landscape": "A4 横",
      "a3-portrait": "A3 縦",
      "a3-landscape": "A3 横",
      "letter-portrait": "Letter 縦",
      "letter-landscape": "Letter 横"
    },
    proOnly: "AI修正（Pro）",
    comingSoon: "準備中",
    loginRequired: "ログインして利用",
    loginNote: "ログインしてAI修正を利用できます。Freeプランでも月最大5回まで試せます。",
    markdownNotSupported: "AI修正は HTML / React / Canvas 向けです。Markdown はエディタで直接編力してください。",
    markdownNotSupportedShort: "Markdown では AI修正を利用できません",
    paidPlanBadge: "Pro",
    upgradeNote: "プランをアップグレードすると、月の利用枠が増えます。",
    instructionRequired: "指示を入力してください",
    codeRequired: "先にコードを貼るか書いてください",
    requestFailed: "AI修正に失敗しました",
    invalidResponse: "AIの応答が不正です",
    remaining: "消化率 {pct}%",
    quotaPercent: "消化率 {pct}%",
    quotaOk: "消化率 {pct}%",
    quotaNear: "消化率 {pct}%",
    quotaExhausted: "今月の利用枠に達しました",
    viewUsage: "利用状況を見る"
  },

  usage: {
    title: "利用状況",
    short: "利用状況",
    subtitle: "今月の利用枠の消化率です。",
    currentPlan: "現在のプラン",
    percentLabel: "今月の消化率",
    exhausted: "今月の利用枠に達しています。",
    resetOn: "次回リセット（プラン開始日起点）",
    refresh: "更新",
    retry: "再試行",
    loading: "読み込み中…",
    loadFailed: "利用状況の読み込みに失敗しました。APIサーバーが起動しているか、Supabase設定を確認してください。",
    notConfigured: "利用状況を取得できません",
    loginRequired: "利用状況を見るにはログインが必要です。"
  },

  billing: {
    plans: "プラン",
    upgrade: "アップグレード",
    comingSoon: "準備中",
    title: "プランを選択",
    subtitle: "月あたりのAI修正回数に応じてプランを選べます。有料プランは現在準備中です。",
    upgradeToLight: "Pro にアップグレード",
    upgradeToPro: "Pro にアップグレード",
    upgradeToBusiness: "Business にアップグレード",
    currentPlan: "現在のプラン",
    manage: "管理",
    manageSubscription: "請求・解約を管理",
    processing: "処理中…",
    failed: "決済の開始に失敗しました",
    success: "お支払いが完了しました。プランを更新しています…",
    canceled: "お支払いをキャンセルしました。",
    downgradeViaPortal: "ダウングレード・解約は請求ポータルから行えます。"
  },

  auth: {
    login: "ログイン",
    logout: "ログアウト",
    loginTitle: "ログイン",
    magicLinkHint: "メールアドレスを入力するとログインリンクを送信します。",
    sendLoginLink: "ログインリンクを送信",
    sending: "送信中…",
    checkEmail: "ログインリンクをメールで送信しました。メール内のリンクを開いてください。",
    sendFailed: "ログインリンクの送信に失敗しました",
    planFree: "Free",
    planLight: "Pro",
    planPro: "Pro",
    planBusiness: "Business"
  },

  admin: {
    title: "管理画面",
    back: "戻る",
    stats: "統計",
    users: "ユーザー",
    totalUsers: "ユーザー総数",
    monthEdits: "今月のAI修正回数",
    freeBudget: "無料枠の使用量",
    freeBudgetSetting: "無料枠の月間予算",
    save: "保存",
    refresh: "再読込",
    email: "メール",
    plan: "プラン",
    usage: "今月の使用回数",
    created: "登録日",
    actions: "操作",
    resetQuota: "クォータリセット",
    adminTag: "管理者",
    cannotChangeAdmin: "管理者のプランは変更できません",
    noUsers: "ユーザーなし",
    loading: "読み込み中…",
    notConfigured: "管理APIが未設定です"
  },

  // LandingPage.js texts
  landing: {
    title: "FrontPlay",
    subtitle1: "AIチャット生成コード専用",
    subtitle2: "実行環境",
    description1: "ChatGPT、Claude、Geminiなどで生成されたコードを、",
    description2: "安全に確かめて",
    description3: "、成果物まで届ける。",
    description4: "",
    getStartedButton: "今すぐ始める",
    featuresButton: "機能を見る",
    nav: {
      useCases: "活用シーン",
      features: "機能",
      security: "セキュリティ",
      plans: "料金プラン"
    },
    backToTop: "トップへ戻る",
    securityTitle: "エンタープライズ級セキュリティを標準装備",
    securitySubtitle: "悪意のあるコードから完全にシステムを保護する多層防御システム",
    sectionTitle: "プロフェッショナル機能",
    sectionSubtitle: "セキュリティと利便性を両立した豊富な機能",
    useCasesTitle: "どんなときに使うか",
    useCasesSubtitle: "確かめることと、届けること。",
    ctaTitle: "まずは動かしてみる",
    ctaDescription1: "生成コードを貼り付けて、すぐ検証を始められます。",
    ctaDescription2: "",
    ctaButton: "FrontPlayを体験する",
    footerTitle: "FrontPlay",
    footerDescription: "AIチャット生成コード専用の安全な実行環境",
    features: {
      enterpriseSecurity: {
        title: "エンタープライズ級セキュリティ",
        description: "サンドボックス化、API制限、多層防御システムにより、悪意のあるコードからシステムを完全保護します。"
      },
      aiCodeExecution: {
        title: "AIコード実行",
        description: "ChatGPT、Claude、Geminiで生成されたコードをそのまま貼り付けて即座に実行できます。"
      },
      realtimeValidation: {
        title: "リアルタイム検証",
        description: "AIが生成したコードの動作を即座に確認し、期待通りに動くかを素早く検証できます。"
      },
      safeExecution: {
        title: "安全な実行",
        description: "AIコードを基に微調整や改良を行い、実行ボタンで安全に結果を確認できます。"
      },
      debugSupport: {
        title: "Console & Network 可視化",
        description: "Console / Network / Errors の3タブで実行結果を同時確認。通信は方向・メソッド・URLとともに全件記録し、機密情報の可能性には警告バッジを表示します。"
      },
      multiFormat: {
        title: "マルチフォーマット",
        description: "HTML、React、Canvas等、様々な形式のAI生成コードに対応しています。"
      }
    },
    securityFeatures: {
      sandbox: {
        title: "サンドボックス実行",
        description: "完全に隔離された opaque-origin iframe内で実行し、親ページやローカルストレージへの不正アクセスを防止"
      },
      apiRestriction: {
        title: "通信可視化＋送信確認",
        description: "受信(GET/HEAD/素材読込)は許可＋全件ログ記録、送信(POST/PUT/WebSocket等)はその都度モーダルでユーザー承認。sendBeaconは既定でブロック"
      },
      realtimeMonitoring: {
        title: "ホワイトリスト＆CSP二重防御",
        description: "許可したドメインは永続化し次回から自動許可。ブラウザ標準CSPとJS フックの多層防御で将来のAPI追加や迂回もカバー"
      }
    },
    useCases: {
      isolatedRun: {
        title: "信用できないコードは、隔離して動かす",
        description: "AIが作ったコードは、動かしてみるまで裏で何をするか分かりません。自分のパソコンやファイルには一切触れさせない「安全な実験場」で動かすため、環境を壊す心配なく動作を確かめられます。"
      },
      networkCheck: {
        title: "「裏でどこへデータを送っているか」を見てから決める",
        description: "見た目が正しく動いていても、裏でデータをどこに送っているかは別問題です。外部への送信はすべて確認ダイアログを挟み、機密情報の可能性があれば警告も表示されるため、安全な行き先かどうかを見てから自分で送信を許可できます。"
      },
      codeDeliverable: {
        title: "直せる範囲は自分で、それ以外はAIに",
        description: "ちょっとした修正なら直接編集でAIコストをかけずに対応。複雑な修正はAIに言葉で指示するだけです。どちらもその場ですぐ結果を確認できます。"
      },
      printShare: {
        title: "画面で動いて終わりではなく、印刷・配布できる形にする",
        description: "動作確認して終わりではありません。紙のサイズに合わせてPDFで書き出せば、そのまま印刷したり、資料として配布できる状態になります。"
      }
    },
    footerSections: {
      security: "セキュリティ機能",
      sandboxExecution: "サンドボックス実行",
      apiRestrictionSystem: "通信可視化システム",
      multiLayerDefense: "送信確認＆ホワイトリスト",
      formatSupport: "対応フォーマット"
    },
    codeExample: {
      title: "Hello, FrontPlay!",
      description: "あなたのアイデアをコードで表現しよう",
      buttonText: "クリックしてね！"
    },
    plans: {
      title: "料金プラン",
      subtitle: "基本機能はすべて無料。AI修正は使い方に合わせて選べます。",
      free: {
        name: "Free",
        priceLabel: "$0",
        features: [
          "サンドボックス内でコードを実行・編集・プレビュー",
          "Console / Network / Errors の可視化",
          "通信の送信確認＆ドメインホワイトリスト",
          "AI修正 月最大5回（要ログイン）"
        ],
        cta: "無料で始める"
      },
      light: {
        name: "Pro",
        badge: "モデル込み",
        priceLabel: "$2/mo",
        features: [
          "Freeのすべての機能（基本機能は無料）",
          "AI修正 月最大50回",
          "AIモデル代込み（キー不要）"
        ],
        cta: "準備中"
      },
      business: {
        name: "Business",
        badge: "要相談",
        priceLabel: "要相談",
        features: [
          "Freeのすべての機能（基本機能は無料）",
          "チーム・法人向けカスタム",
          "個別見積り・優先サポート"
        ],
        cta: "お問い合わせ"
      }
    }
  },

  // Network visibility + send-confirm UI texts
  network: {
    consoleTab: "コンソール",
    networkTab: "ネットワーク",
    errorsTab: "エラー",
    consoleEmpty: "コンソール出力はありません",
    errorsEmpty: "エラーはありません",
    empty: "通信記録はありません",
    method: "メソッド",
    direction: "方向",
    url: "URL",
    status: "状態",
    sensitiveTip: "機密情報の可能性",
    highEntropyTip: "高エントロピー値を検出",
    cspTip: "CSPによりブロック",
    confirmTitle: "外部へのデータ送信を検出しました",
    confirmSubtitle: "このリクエストを許可しますか？",
    bodyLabel: "Body (先頭)",
    allowOnce: "今回のみ許可",
    allowAlways: "常に許可",
    deny: "拒否",
    closeAria: "閉じる",
    whitelistTitle: "通信許可リスト",
    whitelistSubtitle: "ここで許可したドメインは、次回以降モーダルなしで許可されます。",
    domain: "ドメイン",
    send: "送信",
    beacon: "Beacon",
    add: "追加",
    whitelistEmpty: "許可済みドメインはありません",
    whitelistPlaceholder: "example.com"
  },

  // SecurityWarning.js texts
  security: {
    title: "セキュリティに関する重要な注意事項",
    warningTitle: "コード実行時の注意点",
    securityTitle: "FrontPlayのセキュリティ対策",
    disclaimer: "免責事項：",
    disclaimerText: "FrontPlayは安全な実行環境を提供しますが、実行するコードの内容についてはユーザーの責任となります。不明なコードや疑わしいコードの実行は自己責任で行ってください。",
    agreementText: "上記の注意事項を理解し、安全にコードを実行することに同意します",
    acceptButton: "理解して開始する",
    cancelButton: "キャンセル",
    warnings: [
      "信頼できるAI（ChatGPT、Claude、Gemini等）が生成したコードのみを実行してください",
      "個人情報、パスワード、API キーなどの機密情報を含むコードは実行しないでください",
      "悪意のあるコードや不明なコードの実行は避けてください",
      "ネットワーク通信を行うコードには特に注意してください"
    ],
    securityMeasures: [
      "サンドボックス化されたiframe内での実行",
      "外部リソースへのアクセス制限",
      "データの永続化なし（ブラウザ内のみ）",
      "親ページへのアクセス制限",
      "ローカルストレージアクセス制限"
    ]
  }
};